import { CreateScenarioGroupDocument } from '@/generated/graphql';
import { useMyUser } from '@/user/composables/useMyUser';
import { useMutation } from '@vue/apollo-composable';
import { Ref, toValue } from 'vue';
import { ScenarioGroupCreateSchemaType } from '../forms/schemas';

export function useScenarioGroupCreate(data: Ref<ScenarioGroupCreateSchemaType>) {
    const createScenarioGroupMutation = useMutation(CreateScenarioGroupDocument);
    const { currentUser } = useMyUser();

    async function create() {
        const response = await createScenarioGroupMutation.mutate({
            ...toValue(data),
            createdById: toValue(currentUser).id,
            createdByName: toValue(currentUser).name,
        });
        if (response?.errors) {
            throw new Error(`Could not create ScenarioGroup: ${response.errors}`);
        }
        if (!response?.data?.createScenarioGroup?.scenarioGroup) {
            throw new Error('Create ScenarioGroup did not return data.');
        }
        return response.data.createScenarioGroup.scenarioGroup;
    }

    return {
        create,
    };
}
